import { alwaysRefetchApiQueryOptions } from 'BreetHelpers';
import {
	useGetDeveloperIntegrationQuery,
	useGetKybDetailsQuery,
	useGetTransactionsEditServicesQuery,
	useGetUserPreferenceQuery,
	useGetUserQuery,
} from 'BreetRedux';

const TOTAL_ONBOARDING_TASKS = 6;

export const useOnboardingTodoListApi = () => {
	const { data: userPreferenceData, isFetching: userPreferenceFetching } = useGetUserPreferenceQuery(
		undefined,
		alwaysRefetchApiQueryOptions
	);
	const { data: userData, isFetching: userDataFetching } = useGetUserQuery(undefined, alwaysRefetchApiQueryOptions);

	const isKybCompleted = !!userData?.data?.approvedForLive;

	const { data: kybFormData, isFetching: kybFormFetching } = useGetKybDetailsQuery(undefined, {
		...alwaysRefetchApiQueryOptions,
		skip: isKybCompleted,
	});
	const { data: developerIntegrationData, isFetching: developerIntegrationFetching } = useGetDeveloperIntegrationQuery();
	const { isFetching: withdrawalHistoryFetching, data: withdrawalHistoryData } = useGetTransactionsEditServicesQuery(
		{ page: 1, size: 1, defaultParams: '' },
		alwaysRefetchApiQueryOptions
	);

	const isLoading =
		userPreferenceFetching || withdrawalHistoryFetching || kybFormFetching || developerIntegrationFetching || userDataFetching;

	const isMFAAuthentication =
		(userPreferenceData?.data?.usedRecoveryCodesCount ?? 0) + (userPreferenceData?.data?.unusedRecoveryCodesCount ?? 0) > 0 ||
		!!userPreferenceData?.data?.is2FAActive ||
		!!userPreferenceData?.data?.isAuthenticator2FaActive;

	const isFirstTransaction = !!withdrawalHistoryData?.data?.length;

	const isProductionWebhookUrl = !!developerIntegrationData?.data?.webhook?.url;

	const isFirstProductionApiKey = developerIntegrationData?.data?.createdAt === developerIntegrationData?.data?.updatedAt;

	const kybStatus = kybFormData?.data?.status;

	const completedTasksCount = [
		isKybCompleted,
		!isFirstProductionApiKey,
		isProductionWebhookUrl,
		isFirstTransaction,
		isMFAAuthentication,
	].filter(Boolean).length;

	const progressPercentage = Math.round((completedTasksCount / TOTAL_ONBOARDING_TASKS) * 100);

	return {
		kybStatus,
		isFirstProductionApiKey,
		isLoading,
		isMFAAuthentication,
		isFirstTransaction,
		isProductionWebhookUrl,
		progressPercentage,
		isKybCompleted,
	};
};
